import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';
import { get } from 'scriptjs';

@Injectable({
  providedIn: 'root',
})
export class GmapService {
  /**
   * loadLibrary
   *
   */
  loadLibrary(): void {
    get(this.getLibraryUrl(), () => {});
  }

  /**
   * getLibraryUrl
   *
   */
  private getLibraryUrl(): string {
    return (
      environment.shared.gmap.library.url +
      '?key=' +
      environment.shared.gmap.library.key +
      '&callback=Function.prototype'
    );
  }
}
